<template>
    <intranet-nav-content>
        <template slot="links">
            <intranet-nav-content-link-exact :link="{ name: 'Contratos pdf', path: { name: 'admin-hotfix-contracts-pdfs' } }"/>
        </template>
    </intranet-nav-content>
</template>

<script>
import IntranetNavContent from '@/layout/NavContent/IntranetNavContent';
import IntranetNavContentLinkExact from '@/layout/NavContent/IntranetNavContentLinkExact';

export default {
    name: 'ContractLayouts',
    components: { 
        IntranetNavContent,
        IntranetNavContentLinkExact,
    },
};
</script>
